/**
 * Get the number of digits after the decimal point.
 */
export function fractionDigits(value: number | string): number {
  let [basic, power] = value.toString().split(/[eE]/);
  let [, decimal] = basic.split('.');
  return (decimal || '').length - ((power && Number.parseInt(power, 10)) || 0);
}

/**
 * Get the remainder accurately via enlarging the dividend and divisor to integer
 * before mod operation.
 */
export function modAccurately(dividend: number, divisor: number): number {
  const power = Math.max(fractionDigits(dividend), fractionDigits(divisor));
  const multiples = 10 ** power;
  return ((dividend * multiples) % (divisor * multiples)) / multiples;
}
